/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSourceListDto } from '../../models/data-source-list-dto';

export interface DatasourcesGet$Plain$Params {
  search?: string;
}

export function datasourcesGet$Plain(http: HttpClient, rootUrl: string, params?: DatasourcesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataSourceListDto>>> {
  const rb = new RequestBuilder(rootUrl, datasourcesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DataSourceListDto>>;
    })
  );
}

datasourcesGet$Plain.PATH = '/datasources';
